import { createContext, useContext } from 'react';

// Comparte una unica instancia de useHboActivationController entre NodesLayout
// y los puntos de entrada que necesitan interceptar la navegacion (ver TBRFRE-1790 7.2.1)
export const HboActivationContext = createContext(null);

export const useHboActivationContext = () => useContext(HboActivationContext);
